import { render, staticRenderFns } from "./ProformaCorpCard.vue?vue&type=template&id=57378782&"
import script from "./ProformaCorpCard.vue?vue&type=script&lang=js&"
export * from "./ProformaCorpCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports